import React, { Component } from "react";
import {FormBlocks} from '../FormBlocks';
import { connect } from 'react-redux';
import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
import { getUserAuthorities,getWindowIcons ,getProfileAuthorities, getUserInfo } from '../../../../../Utils/UserFunctions';
import LookupModal from './LookupModal';
import Autocomplete from "../../../../AutoComplete";
import { withRouter } from "react-router";
import { callGET,callPOST } from '../../../../../Utils/ApiUtil';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import {isSet,getSelectedValueBasedOnField,isObject, IsJsonString} from '../../../../../Utils/CommonFunctions';
import { getFieldPropertiesFromGridList } from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import Icons from '../../../../Icons/Icons';
import WindowIcons from "../../../../Icons/WindowIcon";

class Lookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lookupIcon:'fas fa-info',
      isModalOpen:false,
      lookup_layout:{},
      isLoading:false,
      rearranged:false,
      isQuickAddModalOpen:false,
      displayName:'',
      lookupAutoComplete:[],
      name: '',
      typing: false,
      typingTimeout: 0,
      lookupData :{},
      hasNoAccess: false,
    }
  }
  //MODAL POPUP 
  openQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen:true});
  }
  closeQuickCreatePopupFromSugg = ()=>{
    this.setState({isQuickAddModalOpen:false});
    this.LayoutsFormsList('');
  }
  componentDidUpdate =(prevProps,prevState)=>{
    const  {
      item,
      screen
    } = this.props;
    if(this.state.rearranged!==true || (IsJsonString(item.selectedValue)===true && isSet(screen,null)==='Layout')){
      try {
        //  console.log("item.selectedValue",item.displayValue);
          const displayValue = IsJsonString(item.displayValue)?item.displayValue:null;
          const selectedValueJSON = JSON.parse(isSet(displayValue,item.selectedValue));
          if(isSet(selectedValueJSON,null)!==null){
            // console.log('selectedValueJSON',selectedValueJSON);
            let selectedValue  = isSet(selectedValueJSON?.metaTableId,selectedValueJSON.id); 
            let displayName=[];
            let displayNameAll=[];
            if(selectedValueJSON && selectedValueJSON.dpnm){
              displayName.push(selectedValueJSON.dpnm);
              selectedValue = selectedValueJSON.id;
              this.setLookupValuesFromList({label:displayName.join(' '),value:selectedValue,ruleMapping:this.props.rulesMapping});
            }else if(selectedValueJSON && selectedValueJSON.fieldGroups) {
              selectedValueJSON.fieldGroups.map((item)=>{
                item.data.map((itemData)=>{
                  const selectedValueItem = getSelectedValueBasedOnField(itemData);
                  if(isObject(selectedValueItem)===true){return false;}
                  if(itemData.element!=='ImageUpload' && selectedValueItem!=='' && selectedValueItem!==undefined && selectedValueItem!==null && selectedValueItem!=='-'){
                    displayNameAll.push(selectedValueItem);
                    if(itemData.is_default_displayname===true && displayName.length<2){
                      displayName.push(selectedValueItem);
                    }
                  }
                });
                const endPos = (displayNameAll.length<=2)? displayNameAll.length:2;
                displayName = (displayName.length===0)?displayNameAll.slice(0,endPos):displayName;
                this.setLookupValuesFromList({label:displayName.join(' '),value:selectedValue,ruleMapping:this.props.rulesMapping});
              })
          }
         }
        } catch (e) {
          // console.log('exceptionLookup..',item);
          if(isSet(item.displayValue,null)!==null){
            // this.setState({rearranged:true});
            this.setLookupValuesFromList({label:item.displayValue,value:item.selectedValue,ruleMapping:this.props.rulesMapping});
          }
        }
    }
     if (prevProps.item.selectedValue!==this.props.item.selectedValue){
      //item.displayValue
      if(isSet(item.selectedValue,null)===null){
        this.setState({displayName:''});
      }
      // console.log('selectedvsl',item.selectedValue);
    }
  }
  componentDidMount = ()=>{
    this.LayoutsFormsList('');
    if(getUserAuthorities()!==null && getUserAuthorities().code===200 && getUserAuthorities().data.length>0){
      getUserAuthorities().data.map((winItem,index)=>{
        if(winItem.module_name==='CRM'){
          winItem.windows.map((window,windowIndex)=>{
            if(this.props.item.value===window.window_name){
              this.setState({lookupIcon:window.css_property})
            }
            return true;
          });
          
        }
        return true;
      });
  }
  }
  //MODAL POPUP FOR ADD NEW - OPEN
  openLoopupModalHandler = () =>{
    this.setState({isModalOpen:true});
  }
  //MODAL POPUP - CANCEL
  cancelLoopupModalHandler = () =>{    
    this.setState({isModalOpen: false});
  }

  

  setLookupValuesFromList = (res) =>{
    // console.log('selectedValueJSON res',res);
    this.setState({displayName:res.label,rearranged:true});
    const {lookupData} = this.state;
    const  {value} = res;
    let fieldObj = {...this.props.fieldObj};
    Object.entries(lookupData).map(([key, Data]) => {
      if(key === value){
        fieldObj = {...fieldObj,lookupData : Data}
      }
    });
    this.props.onChangeInputAction(fieldObj,{
      stateValue:res,
      selectedValue:res.value,
      displayValue:res.label,
      ruleMapping:[res.ruleMapping]
    },'Lookup');
    
  }
  setLookupDataHandler = (data)=>{
    this.setState({
      lookupData:{...this.state.lookupData,...data}
    });
  }

  LayoutsFormsList =(value) =>{
    if(this.props.item.modType==='LAYOUT'){ return false; }
    if(this.props.item.is_subform===true){ return false; } // my code 07 - Avoid subform exception
    // console.log('layoutList',this.props.item.value);
    // const windowName = this.props.windowName;
    const restrictedFields = ["add", "edit", "clone"];
    const params = this.props.match.params;
    const paramsPage = isSet(params.page,'');
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 10;//pagination.perPage; 
    const direction = 'ASC';//pagination.direction; 
    const search = value;
    // parent_layout_id:params.layoutId,
    // parent_window_id:params.windowId,
    this.setState({isLoading:true});
    let API_URL = '';
    const queryString = '?query='+encodeURIComponent(search)+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
    if (!restrictedFields.includes(paramsPage.toLowerCase())) {
      API_URL = 'table-data-engine/' + this.props.item.value + '/metatable/dropdown-list/active' + queryString
    } else {
      API_URL = 'table-data-engine/' + this.props.item.value + '/metatable/dropdown-list' + queryString
    }
    callGET(API_URL)
    .then(res => {
      this.setState({isLoading:false});
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          let updateTableData = [];
          let fieldsRow;
          let defaultDisFieldsRow;
          let gridList = response.data.grid_list;
          const layout_rule_map = isSet(response.data.layout_rule_map,{});
          const lookupData = isSet(response.data.lookup_data,{});
          this.setState({lookup_layout:{
            lookupLayoutId:response.data.lookup_layout_id,
            moduleId:response.data.module_id,
            windowId:response.data.window_id,
            windowName:this.props.item.value},
            lookupData :lookupData
          });
          // console.log('response.data.value_list.content',response.data.value_list.content);
          response.data.value_list.content.map((contentData,contentIndex)=>{
            if(this.props.layoutObject.meta_table_id!==contentData.id){

            
            //console.log(contentData,'contentData==')
            fieldsRow = [];
            let fieldsTableRow  = {};
            defaultDisFieldsRow = [];
            
            // contentData.fields.map((item)=>{
              // item.selectedValue = item.value;
              // item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='FileUpload'  || (item.element_type==='ImageUpload' && item.files.length===0))?'TextInput':item.element_type;
              // item.options = [];
              // const selectedValue = (item.element_type==='CheckBoxes')?'':getSelectedValueBasedOnField(item);
              

              fieldsTableRow = {
                ...fieldsTableRow,
                [contentData.id]:{
                  isDefaultDisplay:false,//item.is_default_displayname,
                  value:contentData.dpnm
                }
              }
              // if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null && selectedValue!=='-'){
              //   if(item.api_field_name==='is_active'){ return false; }
              //   fieldsRow.push(selectedValue);
                   fieldsRow.push(contentData.dpnm);
              //   const property  = getFieldPropertiesFromGridList(gridList,item.table_descriptor_id);
              //   if(isSet(property.is_default_displayname,false)===true && defaultDisFieldsRow.length<2){
                  // defaultDisFieldsRow.push(selectedValue);
                  defaultDisFieldsRow.push(contentData.dpnm);
              //   }
              // }
          // });//
          
          
          const endPos = (fieldsRow.length<=2)? fieldsRow.length:2;
            fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;            
            if(fieldsRow.length>0){
              updateTableData.push({
                label:fieldsRow.join(' '),
                value:contentData.id,
                ruleMapping:isSet(layout_rule_map[contentData.id],{}),
                fields:fieldsTableRow
              });
            }
          }
        })
      
        // console.log("updateTableData",updateTableData);
        
        if(getUserInfo().data.is_external && updateTableData.length == 1 && this.props.item.value == "Accounts"){
          this.autoCompleteSelect(updateTableData.at(0));
          this.setState({hasNoAccess: !this.state.hasNoAccess,lookupAutoComplete:updateTableData})
        }else{
          this.setState({lookupAutoComplete:updateTableData});
        }
        // console.log('updateTableData',updateTableData);
        
        }else{
          this.setState({lookupAutoComplete:[]});
        }
      }
    })
    .catch(err => {
      this.setState({isLoading:false});
        //this.props.Loader(false);
        //this.props.failMessage("Something went wrong...");
        // this.props.history.push('/shipping/rate/getRates/carrier');
        // console.log(err, 'ddddddddd');
      }) 
  }
  autoCompleteSelect = (obj) =>{
    //console.log("ruleMapping",obj);
    this.setLookupValuesFromList({...obj,label:obj.label,value:obj.value})
  }
  autoCompleteSearch = (value) =>{
    this.setState({displayName:value});
    const self = this;

    if (self.state.typingTimeout) {
       clearTimeout(self.state.typingTimeout);
    }
    // console.log('value',value);
    self.setState({
       name: value,
       typing: false,
       typingTimeout: setTimeout(function () {
           self.LayoutsFormsList(value);
         }, 300)
    });
    // setTimeout(() => {
    //   this.LayoutsFormsList(value);
    // }, 200);
  }
  render() {
    //console.log(this.state.lookupAutoComplete, 'this.state.lookupAutoComplete')
    const  {
      item,
      className,
      section,
      validationForms,
      subformObj
    } = this.props;
    const {
      displayName
    } = this.state;

    // const updateData = {
    //   section_index:section.section_index,
    //   itemIndex:item.itemIndex,
    //   item:item,
    //   ...subformObj
    // }
    const WindowProfile = getProfileAuthorities();
    const svgIcons =getWindowIcons();
    let windowIcon ="";
    let isSystemIcon=true;
    let htmlCode ='';
    let sourceImage=''; 
    WindowProfile.data.windows.map((window) => {
      if(window.window_name===item.value & window.window_icon!==undefined ){
        windowIcon=window.window_icon;
        isSystemIcon=window.is_system_icon;
        if(window.is_system_icon===false){ 
          svgIcons.map((svg,i)=>{
            if(svg.id===window.window_icon){
              htmlCode=svg.icon_name;
              sourceImage = 'data:image/svg+xml;base64,'+svg.svg_icon;	
            }

          });
        }
      }
    })
    const attr = formFieldsAttributes(
      {...item,className:className,hideMandatory:true
    },validationForms);

    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
       readonlyVal = attr.fieldAttributes.readOnly;
    }
    // console.log('lookupAutoComplete',this.state.lookupAutoComplete);
    try{
      return (
     
        <Wrp>
        <FormBlocks {...this.props}  attr={attr}>
          <div className={`input-group autocomplete ${this.state.hasNoAccess ? 'noAccess' : ''}`} >
            <input 
              type="hidden"
              value={attr.value}
              // extraId={`ITEMID-${item.id}`}
              {...attr.fieldAttributes}
              autoComplete="new-lookup"
            />
              <Autocomplete
              attributes={attr.fieldAttributes}
              suggestions={this.state.lookupAutoComplete}
              search={this.autoCompleteSearch}
              select={this.autoCompleteSelect}
              selectedValue={(displayName)}//?item.displayValue!==undefined)?item.displayValue:''
              openQuickCreatePopup={this.openQuickCreatePopup}
              isDisable={readonlyVal}
              isLoading={this.state.isLoading}
              {...this.props}
            />
            { readonlyVal !== true ?
            <div className={(item.required===true)? "input-group-append mandatory":"input-group-append"} onClick={this.openLoopupModalHandler}> <a className="input-group-text">
            {/* <i className={this.state.lookupIcon}></i> */}
              {/* <Icons iconType={item.value} size={17} color={'#000'}/> */}
              {isSet(windowIcon,null)!==null?(!isSystemIcon?
									<img src={sourceImage}  width='16' height='16' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>

								   :<WindowIcons size={16} color = {'#000'}windowIcon={windowIcon}/>):
                   <Icons iconType={item.value} size={16} color={'#000'}/>
								}
              </a></div>
            : null }
          </div>
        </FormBlocks>
        {(item.modType!=='LAYOUT')?
            <LookupModal 
            {...this.props}
            item={item}
            isModalOpen={this.state.isModalOpen} 
            windowName={item.value}
            selectedValue={item.selectedValue}
            isQuickAddModalOpen={this.state.isQuickAddModalOpen}
            cancelLoopupModalHandler={this.cancelLoopupModalHandler}            
            setLookupValuesFromList={this.setLookupValuesFromList}
            lookup_layout={this.state.lookup_layout}
            closeQuickCreatePopupFromSugg={this.closeQuickCreatePopupFromSugg}
            setLookupDataHandler={this.setLookupDataHandler}
            />
          :''} 
        </Wrp>
      
      );  
    }catch(e){
      this.props.failMessage("Something went wrong while removing layout");
    }
    
  }
}

Lookup.defaultProps = {
  className: "form-control custom-arrow",
}

export default
connect(
  state => ({
    
    layoutObject:state.formBuilder.layoutObject['ADDFORM'],
  }), 
  
)(withRouter(Lookup));

